import dayjs from 'dayjs'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(advancedFormat)
dayjs.extend(updateLocale)
dayjs.updateLocale('en', {
  weekStart: 1,
})
